export default __webpack_public_path__ + "static/media/whatsapp.1dd8ca27.png";